export default Object.freeze({
  blue: 'blue',
  blueBg: 'blue-bg',
  blue100: 'blue lighten-3',
  blue200: 'blue lighten-2',
  blue300: 'blue lighten-1',
  blue400: 'blue',
  blue500: 'blue darken-1',
  blue600: 'blue darken-2',

  primary: 'primary',
  primary100: 'primary lighten-3',
  primary200: 'primary lighten-2',
  primary300: 'primary lighten-1',
  primary400: 'primary',
  primary500: 'primary darken-1',
  primary600: 'primary darken-2',

  info: 'info',
  info100: 'info lighten-3',
  info200: 'info lighten-2',
  info300: 'info lighten-1',
  info400: 'info',
  info500: 'info darken-1',
  info600: 'info darken-2',

  purple: 'purple',
  purple100: 'purple lighten-4',
  purple200: 'purple lighten-3',
  purple300: 'purple lighten-2',
  purple400: 'purple lighten-1',
  purple500: 'purple',

  indigo: 'indigo',
  indigo100: 'indigo lighten-4',
  indigo200: 'indigo lighten-3',
  indigo300: 'indigo lighten-2',
  indigo400: 'indigo lighten-1',
  indigo500: 'indigo',

  green: 'green',
  green100: 'green lighten-2',
  green200: 'green lighten-1',
  green300: 'green',

  error: 'error',
  error100: 'error lighten-3',
  error200: 'error lighten-2',
  error300: 'error lighten-1',
  error400: 'error',
  error500: 'error darken-1',

  warning: 'warning',
  warning100: 'warning lighten-3',
  warning200: 'warning lighten-2',
  warning300: 'warning lighten-1',
  warning400: 'warning',
  warning500: 'warning darken-1',

  success: 'success',
  success100: 'success lighten-4',
  success200: 'success lighten-3',
  success300: 'success lighten-2',
  success400: 'success lighten-1',
  success500: 'success',

  grey: 'grey',
  grey100: 'grey lighten-4',
  grey200: 'grey lighten-3',
  grey300: 'grey lighten-2',
  grey400: 'grey lighten-1',
  grey500: 'grey',
  grey600: 'grey darken-1',
  grey700: 'grey darken-2',

  black: 'black',
  white: 'white',
  transparent: 'transparent',

  text: {
    blue: 'blue--text',
    blue100: 'blue--text text--lighten-3',
    blue200: 'blue--text text--lighten-2',
    blue300: 'blue--text text--lighten-1',
    blue400: 'blue--text',
    blue500: 'blue--text darken-1',
    blue600: 'blue--text text--darken-2',

    primary: 'primary--text',
    primary100: 'primary--text text--lighten-3',
    primary200: 'primary--text text--lighten-2',
    primary300: 'primary--text text--lighten-1',
    primary400: 'primary--text',
    primary500: 'primary--text text--darken-1',
    primary600: 'primary--text text--darken-2',

    info: 'info--text',
    info100: 'info--text text--lighten-3',
    info200: 'info--text text--lighten-2',
    info300: 'info--text text--lighten-1',
    info400: 'info--text',
    info500: 'info--text text--darken-1',
    info600: 'info--text text--darken-2',

    purple: 'purple--text',
    purple100: 'purple--text text--lighten-4',
    purple200: 'purple--text text--lighten-3',
    purple300: 'purple--text text--lighten-2',
    purple400: 'purple--text text--lighten-1',
    purple500: 'purple--text',

    indigo: 'indigo--text',
    indigo100: 'indigo--text text--lighten-4',
    indigo200: 'indigo--text text--lighten-3',
    indigo300: 'indigo--text text--lighten-2',
    indigo400: 'indigo--text text--lighten-1',
    indigo500: 'indigo--text',

    green: 'green--text',
    green100: 'green--text text--lighten-2',
    green200: 'green--text text--lighten-1',
    green300: 'green--text',

    error: 'error--text',
    error100: 'error--text text--lighten-3',
    error200: 'error--text text--lighten-2',
    error300: 'error--text text--lighten-1',
    error400: 'error--text',
    error500: 'error--text text--darken-1',

    warning: 'warning--text',
    warning100: 'warning--text text--lighten-3',
    warning200: 'warning--text text--lighten-2',
    warning300: 'warning--text text--lighten-1',
    warning400: 'warning--text',
    warning500: 'warning--text text--darken-1',

    success: 'success--text',
    success100: 'success--text text--lighten-4',
    success200: 'success--text text--lighten-3',
    success300: 'success--text text--lighten-2',
    success400: 'success--text text--lighten-1',
    success500: 'success--text',

    grey: 'grey--text',
    grey100: 'grey--text text--lighten-4',
    grey200: 'grey--text text--lighten-3',
    grey300: 'grey--text text--lighten-2',
    grey400: 'grey--text text--lighten-1',
    grey500: 'grey--text',
    grey600: 'grey--text text--darken-1',
    grey700: 'grey--text text--darken-2',

    black: 'black--text',
    white: 'white--text',
  },
})
